export default __webpack_public_path__ + "static/media/search-restaurant.a270457a.svg";